import TopHeroSection from "./Components/TopHeroSection";
import MiddleSection from "./Components/MiddleSection";

import React from "react";

function LandingPage() {
  return (
    <div>
      <TopHeroSection />
      <MiddleSection />
    </div>
  );
}

export default LandingPage;
